import StepSlider from 'common/ui/components/simulation-details/StepSlider/StepSlider';

export default StepSlider;

export * from 'common/ui/components/simulation-details/StepSlider/types';
